<div class="si-radio-dynamic" id="{{id}}">
  <div *ngIf="!hideLabel">
    <si-label [text]="text"
              styleClass="si-radio-dynamic_label"
              [tooltipText]="tooltipText"
              [tooltipPosition]="tooltipPosition"
              [tooltipIcon]="tooltipIcon"
              [tooltipStyleClass]="tooltipStyleClass"
              [tooltipEscape]="tooltipEscape"
              [forceShowTooltipIcon]="forceShowTooltipIcon"
              (tooltipIconClick)="onClickTooltipIcon($event)"
              [disabled]="disabled"
    ></si-label>
  </div>
  <div *ngIf="!options?.length" class="si-radio-dynamic_loader"><i class="icon-spinner"></i></div>
  <div [ngClass]="{'d-flex flex-wrap': !vertical}">
    <div *ngFor="let option of options" class="si-radio-dynamic_radio">
      <si-radio id="dynamic-{{id}}-{{option.id}}"
                name="dynamic-{{id}}-{{option.id}}"
                [(model)]="model"
                (modelChange)="onChangeModel($event)"
                [value]="option"
                [text]="option.name"
                styleClass="{{styleClass}}"
                [disabled]="disabled"
      ></si-radio>
    </div>
  </div>
</div>
